import { assert, } from "./utils";
const tubeCuttingLayerNumber = Object.freeze({
    cuttingOuterContour: 0,
    cuttingInnerContour: 8,
    unfoldCuts: 4,
    tubeOutlines: 5,
});
export function tubeCuttingLayerDescriptor(key, layered) {
    const layerNumber = tubeCuttingLayerNumber[key];
    const descriptor = wsi4.geo.util.layerDescriptorWithNumber(layered, layerNumber);
    assert(descriptor !== undefined, "Expecting valid layer descriptor for layer with number " + layerNumber.toString());
    return descriptor;
}
export function tubeCuttingLayerPaths(key, layered) {
    const layerDescriptor = tubeCuttingLayerDescriptor(key, layered);
    return wsi4.geo.util.layerPaths(layered, layerDescriptor);
}
